/* ZB FIT ESTIMATE (standalone)
 * VERBATIM EXTRACT from assets/zane-barlas-fit.js (the Fit Intelligence engine).
 * DO NOT EDIT THE MATH HERE. If the engine estimator changes, re-extract:
 * round1, getLengthKey, SB_JACKET_CHART_IN, WAISTCOAT_CHART_IN,
 * estimateMetricsV3, getSuitEaseIn, getWaistcoatEaseIn, chooseSizeFromChest.
 * Used by sections/zb-fit-profile.liquid to show the recommended base size
 * on /pages/your-fit, where the React engine does not load.
 */
(function () {
  'use strict';

  const round1 = (n) => Math.round(n * 10) / 10;

  function getLengthKey(lengthLabel) { 
    if (lengthLabel === "Short") return "Short"; 
    if (lengthLabel === "Long") return "Long"; 
    return "Regular"; 
  }

  const SB_JACKET_CHART_IN = {
    Regular: {
      34: { chest: 20.0, waist: 17.6, length: 28.7, sleeve: 24.5, hip: 19.0, shoulder: 17.0, back: 8.1, vent: 9.8, frontLength: 30.1, bicep: 7.7, sleeveOpening: 5.3 },
      36: { chest: 20.8, waist: 18.4, length: 29.1, sleeve: 25.0, hip: 19.8, shoulder: 17.5, back: 8.3, vent: 9.8, frontLength: 30.5, bicep: 7.9, sleeveOpening: 5.3 },
      38: { chest: 21.6, waist: 19.2, length: 29.5, sleeve: 25.5, hip: 20.6, shoulder: 18.0, back: 8.5, vent: 10.0, frontLength: 30.9, bicep: 8.1, sleeveOpening: 5.5 },
      40: { chest: 22.4, waist: 20.0, length: 29.9, sleeve: 26.0, hip: 21.4, shoulder: 18.5, back: 8.9, vent: 10.2, frontLength: 31.3, bicep: 8.3, sleeveOpening: 5.7 },
      42: { chest: 23.2, waist: 20.8, length: 30.3, sleeve: 26.5, hip: 22.2, shoulder: 19.0, back: 9.1, vent: 10.2, frontLength: 31.7, bicep: 8.5, sleeveOpening: 5.7 },
      44: { chest: 24.0, waist: 21.6, length: 30.7, sleeve: 27.0, hip: 23.0, shoulder: 19.5, back: 9.2, vent: 10.4, frontLength: 32.1, bicep: 8.7, sleeveOpening: 5.9 },
      46: { chest: 24.8, waist: 22.4, length: 31.1, sleeve: 27.5, hip: 23.8, shoulder: 20.0, back: 9.4, vent: 10.4, frontLength: 32.5, bicep: 8.9, sleeveOpening: 5.9 },
      48: { chest: 25.6, waist: 23.2, length: 31.5, sleeve: 28.0, hip: 24.6, shoulder: 20.5, back: 9.6, vent: 10.6, frontLength: 32.9, bicep: 9.1, sleeveOpening: 6.1 },
      50: { chest: 26.4, waist: 24.0, length: 31.9, sleeve: 28.5, hip: 25.4, shoulder: 21.0, back: 10.0, vent: 10.8, frontLength: 33.3, bicep: 9.3, sleeveOpening: 6.3 }
    },
    Long: {
      34: { chest: 20.0, waist: 17.6, length: 29.9, sleeve: 25.5, hip: 19.0, shoulder: 17.0, back: 8.1, vent: 10.2, frontLength: 31.3, bicep: 7.7, sleeveOpening: 5.3 },
      36: { chest: 20.8, waist: 18.4, length: 30.3, sleeve: 26.0, hip: 19.8, shoulder: 17.5, back: 8.3, vent: 10.2, frontLength: 31.7, bicep: 7.9, sleeveOpening: 5.3 },
      38: { chest: 21.6, waist: 19.2, length: 30.7, sleeve: 26.5, hip: 20.6, shoulder: 18.0, back: 8.5, vent: 10.4, frontLength: 32.1, bicep: 8.1, sleeveOpening: 5.5 },
      40: { chest: 22.4, waist: 20.0, length: 31.1, sleeve: 27.0, hip: 21.4, shoulder: 18.5, back: 8.9, vent: 10.6, frontLength: 32.5, bicep: 8.3, sleeveOpening: 5.7 },
      42: { chest: 23.2, waist: 20.8, length: 31.5, sleeve: 27.5, hip: 22.2, shoulder: 19.0, back: 9.1, vent: 10.6, frontLength: 32.9, bicep: 8.5, sleeveOpening: 5.7 },
      44: { chest: 24.0, waist: 21.6, length: 31.9, sleeve: 28.0, hip: 23.0, shoulder: 19.5, back: 9.2, vent: 10.8, frontLength: 33.3, bicep: 8.7, sleeveOpening: 5.9 },
      46: { chest: 24.8, waist: 22.4, length: 32.3, sleeve: 28.5, hip: 23.8, shoulder: 20.0, back: 9.4, vent: 10.8, frontLength: 33.7, bicep: 8.9, sleeveOpening: 5.9 },
      48: { chest: 25.6, waist: 23.2, length: 32.7, sleeve: 29.0, hip: 24.6, shoulder: 20.5, back: 9.6, vent: 11.0, frontLength: 34.1, bicep: 9.1, sleeveOpening: 6.1 },
      50: { chest: 26.4, waist: 24.0, length: 33.1, sleeve: 29.5, hip: 25.4, shoulder: 21.0, back: 10.0, vent: 11.2, frontLength: 34.4, bicep: 9.3, sleeveOpening: 6.3 }
    },
    Short: {
      34: { chest: 20.0, waist: 17.6, length: 27.6, sleeve: 23.5, hip: 19.0, shoulder: 17.0, back: 8.1, vent: 9.4, frontLength: 28.9, bicep: 7.7, sleeveOpening: 5.3 },
      36: { chest: 20.8, waist: 18.4, length: 28.0, sleeve: 24.0, hip: 19.8, shoulder: 17.5, back: 8.3, vent: 9.4, frontLength: 29.3, bicep: 7.9, sleeveOpening: 5.3 },
      38: { chest: 21.6, waist: 19.2, length: 28.4, sleeve: 24.5, hip: 20.6, shoulder: 18.0, back: 8.5, vent: 9.6, frontLength: 29.7, bicep: 8.1, sleeveOpening: 5.5 },
      40: { chest: 22.4, waist: 20.0, length: 28.7, sleeve: 25.0, hip: 21.4, shoulder: 18.5, back: 8.9, vent: 9.8, frontLength: 30.1, bicep: 8.3, sleeveOpening: 5.7 },
      42: { chest: 23.2, waist: 20.8, length: 29.1, sleeve: 25.5, hip: 22.2, shoulder: 19.0, back: 9.1, vent: 9.8, frontLength: 30.5, bicep: 8.5, sleeveOpening: 5.7 },
      44: { chest: 24.0, waist: 21.6, length: 29.5, sleeve: 26.0, hip: 23.0, shoulder: 19.5, back: 9.2, vent: 10.0, frontLength: 30.9, bicep: 8.7, sleeveOpening: 5.9 },
      46: { chest: 24.8, waist: 22.4, length: 29.9, sleeve: 26.5, hip: 23.8, shoulder: 20.0, back: 9.4, vent: 10.0, frontLength: 31.3, bicep: 8.9, sleeveOpening: 5.9 },
      48: { chest: 25.6, waist: 23.2, length: 30.3, sleeve: 27.0, hip: 24.6, shoulder: 20.5, back: 9.6, vent: 10.2, frontLength: 31.7, bicep: 9.1, sleeveOpening: 6.1 },
      50: { chest: 26.4, waist: 24.0, length: 30.7, sleeve: 27.5, hip: 25.4, shoulder: 21.0, back: 10.0, vent: 10.4, frontLength: 32.1, bicep: 9.3, sleeveOpening: 6.3 }
    }
  };

  const WAISTCOAT_CHART_IN = {
    "Regular": {
      32: { chest: 17.6, waist: 16.2, hip: 17.2, length: 22.8 },
      34: { chest: 18.4, waist: 17.0, hip: 18.0, length: 23.0 },
      36: { chest: 19.0, waist: 17.8, hip: 18.8, length: 23.2 },
      38: { chest: 19.8, waist: 18.6, hip: 19.4, length: 23.4 },
      40: { chest: 20.6, waist: 19.2, hip: 20.2, length: 23.6 },
      42: { chest: 21.4, waist: 20.0, hip: 21.0, length: 23.8 },
      44: { chest: 22.2, waist: 20.8, hip: 21.8, length: 24.0 },
      46: { chest: 23.0, waist: 21.6, hip: 22.6, length: 24.2 },
      48: { chest: 23.8, waist: 22.4, hip: 23.4, length: 24.4 },
      50: { chest: 24.6, waist: 23.2, hip: 24.2, length: 24.6 }
    },
    "Short": {
      32: { chest: 17.6, waist: 16.2, hip: 17.2, length: 21.8 },
      34: { chest: 18.4, waist: 17.0, hip: 18.0, length: 22.0 },
      36: { chest: 19.0, waist: 17.8, hip: 18.8, length: 22.2 },
      38: { chest: 19.8, waist: 18.6, hip: 19.4, length: 22.4 },
      40: { chest: 20.6, waist: 19.2, hip: 20.2, length: 22.6 },
      42: { chest: 21.4, waist: 20.0, hip: 21.0, length: 22.8 },
      44: { chest: 22.2, waist: 20.8, hip: 21.8, length: 23.0 },
      46: { chest: 23.0, waist: 21.6, hip: 22.6, length: 23.2 },
      48: { chest: 23.8, waist: 22.4, hip: 23.4, length: 23.4 },
      50: { chest: 24.6, waist: 23.2, hip: 24.2, length: 23.6 }
    },
    "Long": {
      32: { chest: 17.6, waist: 16.2, hip: 17.2, length: 23.8 },
      34: { chest: 18.4, waist: 17.0, hip: 18.0, length: 24.0 },
      36: { chest: 18.8, waist: 17.4, hip: 18.4, length: 24.2 },
      38: { chest: 19.6, waist: 18.2, hip: 19.0, length: 24.4 },
      40: { chest: 20.4, waist: 18.8, hip: 19.8, length: 24.6 },
      42: { chest: 21.2, waist: 19.6, hip: 20.6, length: 24.8 },
      44: { chest: 22.0, waist: 20.4, hip: 21.4, length: 25.0 },
      46: { chest: 22.8, waist: 21.2, hip: 22.2, length: 25.2 },
      48: { chest: 23.6, waist: 22.0, hip: 23.0, length: 25.4 },
      50: { chest: 24.4, waist: 22.8, hip: 23.8, length: 25.6 }
    }
  };

  function estimateMetricsV3({ heightCm, weightKg, age, shoe, shape }) {
    const height = Number(heightCm);
    const weight = Number(weightKg);
    const userAge = Number(age) || 35;
    const userShoe = Number(shoe) || 10;
    const bodyShape = shape || "Rectangle";
    
    // 1. Frame Factor
    const expectedShoe = (height - 140) / 4.5;
    const frameMult = 1 + ((userShoe - expectedShoe) * 0.015);
    
    // 2. Base Physics
    // Chest: (0.7 * W) + (0.25 * H). 72kg/183cm → 96.15cm (37.8")
    let baseChestCm = (0.7 * weight) + (0.25 * height);
    
    // Waist: (0.95 * W) + 12. 72kg → 80.4cm (31.6")
    let baseWaistCm = (0.95 * weight) + 12;
    
    // Thigh: (0.28 * W) + 40. 72kg → 60.16cm (23.6")
    const baseThighCm = (0.28 * weight) + 40;
    
    // Neck: Skin-First. 72kg → 37cm (14.6")
    const baseNeckCm = 34 + ((weight - 60) * 0.25);
    
    // NEW: Hip/Seat Estimation (Waist + ~16cm/6.3")
    // Matches garment drop (e.g., Waist 34 → Hip ~41")
    const baseHipCm = baseWaistCm + 16;
    
    // 3. SHAPE MODIFIERS (Calibrated)
    // Inverted: +4cm Chest to ensure 72kg hits 38R (not 36R)
    if (bodyShape === "Inverted Triangle" || bodyShape === "Inverted") {
      baseChestCm += 4;    // +1.6" chest (V-shape/swimmer build)
      baseWaistCm -= 2;    // Narrower waist
    } else if (bodyShape === "Rectangle") {
      baseWaistCm += 2;    // Slightly wider waist
    } else if (bodyShape === "Triangle") {
      baseWaistCm += 4;    // Wider waist (pear shape)
    }
    // Oval shape: no modifier (default proportions)
    
    // 4. Age Adjustments (REDUCED from 0.5 to 0.3 to prevent oversizing)
    const chestAdj = Math.max(0, userAge - 35) * 0.3;
    const waistAdj = Math.max(0, userAge - 28) * 0.5;
    
    // 5. Apply adjustments
    const finalChestCm = (baseChestCm + chestAdj) * frameMult;
    const finalWaistCm = baseWaistCm + waistAdj;
    const finalHipCm = baseHipCm + waistAdj; // Hip grows with waist adjustment
    const finalThighCm = baseThighCm; // Thigh not affected by frame/age
    const finalNeckCm = baseNeckCm;   // Neck not affected by frame
    
    // 6. Convert to INCHES
    return {
      bodyChest: round1(finalChestCm / 2.54),
      bodyWaist: round1(finalWaistCm / 2.54),
      bodyHip: round1(finalHipCm / 2.54),   // NEW FIELD
      bodyThigh: round1(finalThighCm / 2.54),
      bodyNeck: round1(finalNeckCm / 2.54)
    };
  }

  function getSuitEaseIn(fitPref) {
    if (fitPref === "Slim") return 2.0;
    if (fitPref === "Classic") return 4.0;
    return 3.0; // Tailored default
  }

  function getWaistcoatEaseIn(fitPref) {
    // Waistcoat ease is smaller (+1.5" for Tailored vs +3" for jackets)
    if (fitPref === "Slim") return 1.0;
    if (fitPref === "Classic") return 2.0;
    return 1.5; // Tailored default
  }

  function chooseSizeFromChest({ bodyChestIn, fitPref, category }) {
    const isWaistcoat = category === "waistcoat";
    const ease = isWaistcoat ? getWaistcoatEaseIn(fitPref) : getSuitEaseIn(fitPref);
    
    // Target body chest (no shape modifiers - physics is physics)
    const targetBodyChest = round1(bodyChestIn);
    
    // Target garment circumference = body + ease
    const targetGarmentChest = targetBodyChest + ease;
    
    const sizes = [32, 34, 36, 38, 40, 42, 44, 46, 48, 50];
    const chart = isWaistcoat ? WAISTCOAT_CHART_IN.Regular : SB_JACKET_CHART_IN.Regular;
    
    // Chart values are FLAT WIDTH (half), so multiply by 2 for circumference
    const minChartHalf = chart[32]?.chest ?? 17.6;
    const maxChartHalf = chart[50]?.chest ?? 24.6;
    const minSupported = round1(minChartHalf * 2 - ease); // Min body chest we can fit
    const maxSupported = round1(maxChartHalf * 2 - ease); // Max body chest we can fit
  
    if (targetBodyChest < minSupported) {
      return { jacketSize: 32, easeIn: ease, bodyChestIn: targetBodyChest, outOfRange: true, outOfRangeDir: "low", supportedMinBodyChestIn: minSupported, supportedMaxBodyChestIn: maxSupported };
    }
    if (targetBodyChest > maxSupported) {
      return { jacketSize: 50, easeIn: ease, bodyChestIn: targetBodyChest, outOfRange: true, outOfRangeDir: "high", supportedMinBodyChestIn: minSupported, supportedMaxBodyChestIn: maxSupported };
    }
  
    let bestSize = 38;
    let bestDiff = Infinity;
  
    for (const s of sizes) {
      const chartHalfWidth = chart[s]?.chest;
      if (chartHalfWidth == null) continue;
      
      // "TIMES 2" RULE: Convert chart flat width to full circumference
      const chartCircumference = chartHalfWidth * 2;
      
      // Find size where garment circumference best matches target
      const diff = Math.abs(chartCircumference - targetGarmentChest);
      
      // Prefer smaller size for Slim/Tailored, larger for Classic
      const preferSmaller = fitPref !== "Classic";
      const isTie = diff === bestDiff;
      const winsTie = preferSmaller ? (s < bestSize) : (s > bestSize);
      
      if (diff < bestDiff || (isTie && winsTie)) { 
        bestDiff = diff; 
        bestSize = s; 
      }
    }
  
    // Slim fit preference: Consider sizing down if within tolerance
    if (fitPref === "Slim") {
      const idx = sizes.indexOf(bestSize);
      const down = idx > 0 ? sizes[idx - 1] : null;
      if (down != null) {
        const downCircumference = (chart[down]?.chest ?? 0) * 2;
        const slimTolerance = 1.0; // Allow 1" tighter fit for slim
        if (downCircumference >= targetGarmentChest - slimTolerance) { 
          bestSize = down; 
        }
      }
    }
  
    return { jacketSize: bestSize, easeIn: ease, bodyChestIn: targetBodyChest, outOfRange: false, outOfRangeDir: null, supportedMinBodyChestIn: minSupported, supportedMaxBodyChestIn: maxSupported };
  }

  // Mirrors the suit path of recommendFromBody() in the engine.
  window.ZBEstimateBaseSize = function (p) {
    if (!p || typeof p.heightCm !== 'number' || typeof p.weightKg !== 'number') return null;
    var metrics = estimateMetricsV3({ heightCm: p.heightCm, weightKg: p.weightKg, age: p.age || 35, shoe: p.shoe, shape: p.bodyShape });
    var lengthKey = 'Regular';
    if (p.heightCm < 168) lengthKey = 'Short';
    if (p.heightCm > 185) lengthKey = 'Long';
    var bmi = p.weightKg / Math.pow(p.heightCm / 100, 2);
    var bmiAdj = 0;
    if (bmi < 18.5) bmiAdj -= 0.6;
    else if (bmi > 30) bmiAdj += 0.8;
    else if (bmi > 26.5) bmiAdj += 0.4;
    var chosen = chooseSizeFromChest({ bodyChestIn: round1(metrics.bodyChest + bmiAdj), fitPref: p.fitPref, category: 'suit' });
    return {
      jacketSize: chosen.jacketSize,
      lengthKey: lengthKey,
      code: String(chosen.jacketSize) + lengthKey.charAt(0),
      trouserSize: chosen.jacketSize - 6,
      outOfRange: !!chosen.outOfRange
    };
  };
})();
